var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDropDown48Filled = function SvgIconArrowDropDown48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.461 20.32a2.89 2.89 0 0 0-2.66-1.75h-9.6a2.9 2.9 0 0 0-2.1 4.89l4.8 5.06a2.88 2.88 0 0 0 3.248.672 2.92 2.92 0 0 0 .962-.672l4.79-5.06a2.891 2.891 0 0 0 .56-3.14Z",
    fill: "current"
  })));
};
export default SvgIconArrowDropDown48Filled;